module.exports = __webpack_public_path__ + "static/media/movimenti.fda25446.svg";